---
en:
  dashboard:
    gwh_ytd: GWh YTD
    m_currency_ytd: m{currency} YTD
    mm_48h: 48H
    of_ytd_average: of YTD average
    plants_in_operation: Plants in Operation
    total_volume: Total volume
    volume_for_asset_type: "{type} volume"
